import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { isUserLogin } from '@eureka/utils/account';

export interface EmbodimentImagesRequest {
    pn: string
    embodiment_name: string
}

export interface EmbodimentImagesDTO {
    embodiment_name: string
    url: string
}

export interface EmbodimentImagesApi {
    getEmbodimentImages(data: EmbodimentImagesRequest): Promise<EmbodimentImagesDTO>;
}

export const EmbodimentImagesApi = Symbol('EmbodimentImagesApi');

@injectable()
export class EmbodimentImagesApiImpl extends PsHttpService implements EmbodimentImagesApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    async getEmbodimentImages(data: EmbodimentImagesRequest) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.post<PatSnapCommonResponseData<EmbodimentImagesDTO>>({
            url: `${base}/patent/embodiment_images`,
            data,
        }).then((res) => {
            return res as unknown as EmbodimentImagesDTO;
        });
    }
}
